
// node modules
import Vue from "vue";
import App from "./App";
import store from "./store/store.js"; // must be lowercase to pass into new Vue()
import BootstrapVue from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VModal from 'vue-js-modal'
import Multiselect from 'vue-multiselect'

// css
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-datetime/dist/vue-datetime.css"
import "vue-multiselect/dist/vue-multiselect.min.css";
import "../index.css";

// Bootstrap and font-awesome icons
Vue.use(BootstrapVue);
library.add(fas);
Vue.component("fa", FontAwesomeIcon);
Vue.config.productionTip = false; 

// vue-js-modal
//https://euvl.github.io/vue-js-modal/Intro.html
Vue.use(VModal, { 
  componentName: "vue-js-modal", 
  dynamicDefault: { draggable: true, resizable: true } 
});

// vue-mutliselect
Vue.component("multiselect", Multiselect);

// init Vue app
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  store
});



// WEBPACK FOOTER //
// ./src/main.js